export default __webpack_public_path__ + "static/media/ic_emoji_w.9be13ff5.svg";